import { format as dateFormat } from 'date-fns'
import fromUnixTime from 'date-fns/fromUnixTime'

export function testDisplayName (testType) {
  switch (testType) {
    case 'Product Concept Testing':
      return 'Concept'
    case 'Usability Testing':
      return 'Usability'
    default:
      return testType
  }
}

export function testStatusDisplayName (testStatus) {
  switch (testStatus) {
    case 'In Review':
      return 'Submitted'
    default:
      return testStatus
  }
}

export function reportSourceType (report) {
  var type

  // Some report objects use config and some
  // put type on the root
  if (report.config && report.config.type) {
    type = report.config.type
  } else if (report.type) {
    type = report.type
  } else {
    type = 'experiment'
  }

  switch (type) {
    case 'view':
      return 'experiment'
    case 'card':
      return 'test'
    default:
      return type
  }
}

export function testSegment (test) {
  var seg = test.payload.segment
  if (seg && typeof seg === 'string' && seg.trim().length > 0) { // legacy audiences
    return seg.trim() === 'General Population' ? 'US Adults' : seg.trim()
  } else if (typeof seg === 'object' && seg.title) { // new format for audiences
    return seg.title
  }
  return 'US Adults'
}

export function testTags (test) {
  var t = test.payload.tags
  if (t) {
    return t.split(',').join(', ')
  }
  return false
}

export function testCreatedAtDate (test) {
  // amazingly we use the real created and not the payload date
  const date = test.payload.date || test.createdAt
  if (!date) return null
  const time = fromUnixTime(date)
  return dateFormat(time, 'MMM dd, yyyy')
}

export function testCreatedAtString (test) {
  const date = testCreatedAtDate(test)
  if (date) {
    return date
  } else {
    return ''
  }
}

export function testTypeFields (testType) {
  switch (testType) {
    // Templates will determine which fields to display
    case 'Template':
    case 'Competitive Overview':
    case 'UX Refinement':
    case 'User Discovery':
      return ['additional_info']
    case 'Comparison':
      return ['description', 'additional_info', 'comparison']
    case 'Product Concept Testing':
      return ['description', 'additional_info', 'concept']
    case 'Feature Prioritization':
    case 'Usability Testing':
    default:
      return ['description', 'additional_info']
  }
}

export function testTypeFieldsForTemplates (testType, context) {
  switch (testType) {
    case 'UX Refinement':
      return ['description', 'webpage']
    case 'Competitive Overview':
    case 'User Discovery':
      return []
    case 'Comparison':
      return ['comparison', 'description', 'additional_info']
    case 'Product Concept Testing':
      return ['description', 'additional_info', 'concept']
    case 'Feature Prioritization':
    case 'Usability Testing':
    default:
      return ['description', 'additional_info']
  }
}

export const testIconMap = {
  'Competitive Overview': 'group_work',
  'User Discovery': 'record_voice_over',
  'Product Concept Testing': 'widgets',
  'Feature Prioritization': 'swap_vert',
  Comparison: 'swap_vert',
  'UX Refinement': 'select_all',
  'Usability Testing': 'screen_rotation',
  Template: 'line_style'
}

export function testStatusColor (status) {
  switch (status) {
    case 'In Testing':
      return '#f5ae4e'
    case 'Analyzing':
      return 'purple'
    case 'Draft':
      return '#AAAAAA'
    case 'In Review':
      return '$bg-secondary'
    case 'In Progress':
      return '#E9B961'
    case 'In Design':
      return 'green'
    case 'Complete':
    case undefined: // Some old tests don't have a status
      return 'transparent'
    default:
      console.error('Unsupported test status for color: ', status)
      return 'transparent'
  }
}
